"use client";
import React, { useState, useEffect } from "react";
import { Search } from "lucide-react";
import { HomeSearch } from "@/app/(home)/_search";
import { usePathname } from "next/navigation";

const NavItemSearchBar: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  const pathname = usePathname();

  useEffect(() => {
    setShowModal(false);
  }, [pathname]);

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="flex items-center justify-center p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
        aria-label="Open search"
      >
        <Search />
      </button>
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ backgroundColor: "rgba(30, 41, 59, 0.7)" }}
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-white dark:bg-slate-900 mx-auto rounded shadow-lg p-6 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
              aria-label="Close search"
            >
              ×
            </button>
            <h2 className="text-lg font-semibold mb-4 text-center text-gray-900 dark:text-gray-100">
              What are you looking for?
            </h2>
            <HomeSearch showLabel={false} />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-4 text-center">
              Proudly brought to you with AI.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default NavItemSearchBar;
